import { useClientPortalAPI } from "@certn/api";
import { components } from "@certn/api/generated-schemas/client-portal";

interface TemplateArguments {
  template_id: string;
}

export function useEmploymentVerificationTemplatesInPackages() {
  const { data: packagesData } = useClientPortalAPI(
    `/api/internal/client-portal/packages/`
  );

  const results: readonly components["schemas"]["PackageList"][] =
    packagesData?.results || [];

  const activePackages = results.filter(({ is_active }) => is_active);

  const flatActivePackageChecks = activePackages
    .map(({ packagecheck_set }) => packagecheck_set)
    .flat();

  const activateEmploymentPackageChecks = flatActivePackageChecks.filter(
    ({ check_type }) => check_type === "EMPLOYMENT_VERIFICATIONS_1"
  );

  const templateIdsBelongingToActivePackages: string[] = Array.from(
    new Set(
      activateEmploymentPackageChecks
        ?.map((packageCheck) => {
          const templateArguments = packageCheck.arguments as TemplateArguments;
          return templateArguments?.template_id || null;
        })
        .filter((id): id is string => id !== null)
    )
  );

  return templateIdsBelongingToActivePackages;
}

export function useGetEmploymentVerificationTemplates() {
  const { data } = useClientPortalAPI(
    `/api/internal/client-portal/check-arguments-templates/employment-verification/`
  );
  const results: components["schemas"]["EmploymentVerificationTemplateList"][] =
    data?.results || [];

  const activeTemplateIds = results
    .filter((template) => template.id && template.is_active)
    .map((template) => template.id);

  const deactivatedTemplateIds = results
    .filter((template) => template.id && !template.is_active)
    .map((template) => template.id);

  return { activeTemplateIds, deactivatedTemplateIds };
}

export function useShouldShowRegulatoryReferences(enabled = true) {
  const { data } = useClientPortalAPI(
    enabled
      ? "/api/internal/client-portal/customer-accounts/customer-groups-list/"
      : null,
    enabled ? { page_size: "1", country: "GB" } : undefined
  );

  return data ? data.count > 0 : false;
}
